import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter/index'

function index() {
    return (
        <DefaultLeadsPage leadType="Dialshreeinbound" />
    )
}

export default index